import clsx from 'clsx';
import { h } from 'preact';

const HeaderNavItem = ({ link, className, onMouseEnter }) => (
  <li className={`group`} onMouseEnter={onMouseEnter}>
    <a
      href={link.url}
      className={clsx(
        'nav-items block group',
        { 'lc:!text-misc-sale ml:!text-error': link.highlighted },
        className,
      )}
    >
      <span className="lg:group-hover:border-current border-b border-transparent">
        {link.text}
      </span>
    </a>
  </li>
);

export default HeaderNavItem;
